import axios from "axios";
import { ApiKey, liveURL } from "../const/constants";

// Base URL for theme configuration
const GET_THEME_CONFIG = `${liveURL}/websiteTheme/getThemeConfig`;

/**
 * Fetches theme configuration from the API.
 * @returns {Promise<Object>} The response data or an error object.
 */
export const getThemeConfig = async () => {
  try {
    const response = await axios.get(GET_THEME_CONFIG, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getThemeConfig:", error);
    return {
      error: "Failed to fetch theme configuration",
      details: error.message,
    };
  }
};
